import { Link } from "react-router-dom";

const related = [
  {
    id: 1,
    label: "Sofa Guide",
    title: "Best Beige Sofas for a Calm Living Room",
    excerpt: "The quiet anchor of any calm room — a guide to choosing the right beige sofa for your space.",
    path: "/cozy-corners/best-beige-sofas",
    image: "https://public.readdy.ai/ai/img_res/ee09f674ffefa66e007234dee17b5133.jpg",
  },
  {
    id: 2,
    label: "Curtain Guide",
    title: "Best Linen Curtains for Soft Beige Rooms",
    excerpt: "Light, airy, and effortlessly warm — how to choose linen curtains that complete a neutral room.",
    path: "/products/linen-curtains",
    image: "https://readdy.ai/api/search-image?query=linen%20curtains%20soft%20beige%20room%20warm%20natural%20light%20sheer%20fabric%20calm%20interior%20editorial%20photography%20neutral%20palette&width=800&height=500&seq=nr_rel2&orientation=landscape",
  },
  {
    id: 3,
    label: "Living Room",
    title: "Soft Beige Living Room Ideas That Feel Calm and Expensive",
    excerpt: "A complete guide to building a warm, layered beige living room from the floor up.",
    path: "/living-room/soft-beige",
    image: "https://readdy.ai/api/search-image?query=soft%20beige%20living%20room%20calm%20elegant%20natural%20light%20linen%20sofa%20wood%20coffee%20table%20neutral%20rug%20editorial%20interior%20photography%20warm%20atmosphere&width=800&height=500&seq=nr_rel3&orientation=landscape",
  },
];

export default function NRRelated() {
  return (
    <section className="py-20 px-8 md:px-16 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>Keep Reading</p>
          <h2 className="text-[#2C2825] text-2xl md:text-3xl" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>Related Articles</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {related.map((article) => (
            <Link key={article.id} to={article.path} className="group flex flex-col cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl mb-5 aspect-[16/10]">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>
              <span className="text-[#B5A898] text-[9px] tracking-[0.35em] uppercase mb-2" style={{ fontFamily: "'Inter', sans-serif" }}>{article.label}</span>
              <h3 className="text-[#2C2825] text-base md:text-lg leading-snug mb-3 group-hover:text-[#6B5E53] transition-colors duration-200" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>{article.title}</h3>
              <p className="text-[#8B8378] text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>{article.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
